export default "/Frontend/dist/asterix.fe06e57e84690d0fbc97a6ea0e645620.svg";